/* ACTION TYPES */
export const NOTIFICATION_ACTIONS = {
    STORE_NOTIFICATIONS: 'STORE_NOTIFICATIONS',
    SET_LOADING_NOTIFICATIONS: 'SET_LOADING_NOTIFICATIONS',
    SET_NOTIFICATIONS_EMPTY: 'SET_NOTIFICATIONS_EMPTY',
    SET_NOTIFICATIONS_AS_READ: 'SET_NOTIFICATIONS_AS_READ',
    SET_HAS_UNREAD_NOTIFICATIONS: 'SET_HAS_UNREAD_NOTIFICATIONS',
};

export enum NotificationUiState {
    LOADING = 'LOADING',
    EMPTY = 'EMPTY',
    SHOWING = 'SHOWING',
}
